export default __webpack_public_path__ + "static/media/stay-duration.774d6f15.svg";